import type { EvidenceAttribution, EvidenceSection } from '../../types/siteEvidence';
import type { SiteDocument } from '../../types/siteRag';
import { flattenLeafValues } from './docConflicts';

/** Record only fields this extraction actually supplied and that survived the merge. */
export function stampDocumentFieldSources(
  slot: EvidenceSection<unknown>,
  doc: Pick<SiteDocument, 'id' | 'fileName'>,
  result: { data: Record<string, unknown>; confidence: number; attribution?: EvidenceAttribution; excerptPreview?: string; pageNumber?: number },
  adoptedFields: readonly string[] = Object.keys(result.data),
): void {
  const current = flattenLeafValues(slot.data);
  const next = { ...(slot.docFieldSources ?? {}) };
  for (const [path, value] of Object.entries(flattenLeafValues(result.data))) {
    if (!adoptedFields.some(field => path === field || path.startsWith(`${field}.`))) continue;
    if (current[path] !== value) continue;
    next[path] = { docId: doc.id, docName: doc.fileName, value, confidence: result.confidence,
      ...(result.attribution ? { attribution: result.attribution } : {}),
      ...(result.excerptPreview ? { excerptPreview: result.excerptPreview } : {}),
      ...(result.pageNumber !== undefined ? { pageNumber: result.pageNumber } : {}),
    };
  }
  slot.docFieldSources = next;
}
